import type { HeaderBiddingConfig } from './types'

export const DEFAULT_HEADER_BIDDING_CONFIG: HeaderBiddingConfig = {
    timeout: 1000,
    bidders: [
        {
            bidder: 'ix',
            params: {
                siteId: '9999990',
            },
        },
        {
            bidder: 'smaato',
            params: {
                publisherId: '1100042525',
                adspaceId: '130563103',
            },
        },
    ],
}
